/* eslint-disable max-len */
const CacheImages = async (srcArray, doThat, progressUpdate = false) => {
    if (!doThat) {
        // resolve(doThat);

        return;
    }

    let progressValue = 0;
    const delta = 100 / srcArray.length;
    const images = srcArray.map(() => new Image());
    const promiseArray = images.map((image, index) => new Promise((resolve) => {
        const handler = () => {
            progressValue += delta;
            if (typeof progressUpdate === 'function') progressUpdate.call(this, progressValue);
            resolve();
        };

        image.onload = handler;
        image.onerror = handler;

        image.src = srcArray[index];
    }));

    await Promise.all(promiseArray);
};

const DownloadImages = async (imagesManifest, doThat, progressUpdate = false) => {
    if (!doThat) {
        // resolve(doThat);

        return false;
    }

    let progressValue = 0;
    const images = imagesManifest.map(({ id, src }) => ([id, { src, id, image: new Image() }]));
    const delta = 100 / images.length;
    const promiseArray = images.map((arr) => new Promise((resolve) => {
        const [, item] = arr;
        const handler = () => {
            progressValue += delta;
            if (typeof progressUpdate === 'function') progressUpdate.call(progressValue);
            resolve();
        };

        item.image.onload = handler;
        item.image.onerror = (e) => {
            item.error = true;
            item.errorEvent = e;
            handler();
        };

        item.image.src = item.src;

    }));

    await Promise.all(promiseArray);

    return Object.fromEntries(new Map(images));
};

const DownloadImagesFunction = (manifest, critical, progressUpdate, store, storage) => (doThat) => DownloadImages(manifest, critical, doThat, progressUpdate, store, storage);

const CacheImagesFunction = (manifest, critical, progressUpdate, store, storage) => (doThat) => CacheImages(manifest, critical, doThat, progressUpdate, store, storage);

export {
    CacheImages, DownloadImages, CacheImagesFunction, DownloadImagesFunction
};
